import React from "react";
import { Row, Col, Card, Button } from 'react-bootstrap';
import { CreditCard, Cash } from 'react-bootstrap-icons';
import { FormattedMessage } from 'react-intl';
import { Link } from "react-router-dom";

const BannerCard = ({ handleBtn }) => {
    return (
        <>
            <Card className='famsa-bg-card'>
                <Card.Body>
                    <Card.Title className='mb-5'>
                        <Row className='justify-content-center mx-2 my-4'>
                            <Col md={{ span: 12 }}>
                                <h3 className='famsa-text-red fw-bold'>
                                    <FormattedMessage id="banner.title1" />
                                </h3>
                            </Col>
                        </Row>
                    </Card.Title>
                    <Card.Text className='mt-3'>
                        <Row className='justify-content-center mx-3 my-4'>
                            <Col md={{ span: 11 }}>
                                <Button className='famsa-btn-w rounded-pill famsa-btn-gradient-blue border-0' onClick={(e) => handleBtn(e, 1)}>
                                    <div className='fs-5 py-1'>
                                        <CreditCard /> <FormattedMessage id="banner.btn.furniture" />
                                    </div>
                                </Button>
                                {/*<Link to="maintenance" className='btn famsa-btn-w rounded-pill famsa-btn-gradient-blue border-0 text-white' role="button">
                                    <div className='fs-5 py-1'>
                                        <CreditCard /> <FormattedMessage id="banner.btn.furniture" />
                                    </div>
                            </Link>*/}
                            </Col>
                        </Row>
                        <Row className='justify-content-center mx-3 my-4'>
                            <Col md={{ span: 11 }} className='border-top'>
                            </Col>
                        </Row>
                        <Row className='justify-content-center mx-3 my-4'>
                            <Col md={{ span: 11 }}>
                                <Button className='famsa-btn-w rounded-pill famsa-btn-gradient-red border-0' onClick={(e) => handleBtn(e, 2)}>
                                    <div className='fs-5 py-1'>
                                        <Cash /> <FormattedMessage id="banner.btn.loan" />
                                    </div>
                                </Button>
                            </Col>
                        </Row>
                        <Row className='my-3'></Row>
                    </Card.Text>
                </Card.Body>
            </Card>
        </>
    );
}

export default BannerCard;